import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {useAppSelector} from "../../../../store/hooks";
import {leadTopicConfig} from "../../../constants/lead/lead_topic_config";
import {LeadTopicType} from "../../../types/lead/LeadTopicType";
import {TopicForm} from "./TopicForm";

type IProps = Omit<ComponentProps<typeof TopicForm>, "customHeader" | "defaultMessage">;

export const LeadModalTopicForm = (props: IProps) => {
    const {handleModalClose} = props;

    const topic = useAppSelector((state) => state.mainLead.topic);

    const {title, message} = useMemo(() => {
        // If a custom title and message are provided, use them
        if (topic.type === LeadTopicType.CUSTOM && topic.title && topic.message) {
            return {
                title: topic.title,
                message: topic.message
            };
        }

        // Otherwise use predefined config
        if (topic.type && topic.type !== LeadTopicType.CUSTOM && topic.type in leadTopicConfig) {
            return leadTopicConfig[topic.type as LeadTopicType];
        }

        // Fallback to empty strings
        return {
            title: "",
            message: ""
        };
    }, [topic]);

    return (
        <div className={css({p: 3, w: "100%", md: {maxW: "556px"}})}>
            <CloseIconButton top={2} right={2} className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

            <TopicForm
                {...props}
                customHeader={
                    <Text variant="headline_4" as="p" mb={3} className={css({textAlign: "left", pr: 4, md: {textAlign: "center"}})}>
                        {title}
                    </Text>
                }
                defaultMessage={message}
            />
        </div>
    );
};

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {useAppSelector} from "../../../../store/hooks";
import {leadTopicConfig} from "../../../constants/lead/lead_topic_config";
import {LeadTopicType} from "../../../types/lead/LeadTopicType";
import {TopicForm} from "./TopicForm";

type IProps = Omit<ComponentProps<typeof TopicForm>, "customHeader" | "defaultMessage">;

export const LeadModalTopicForm = (props: IProps) => {
    const {handleModalClose} = props;

    const topic = useAppSelector((state) => state.mainLead.topic);

    const {title, message} = useMemo(() => {
        // If a custom title and message are provided, use them
        if (topic.type === LeadTopicType.CUSTOM && topic.title && topic.message) {
            return {
                title: topic.title,
                message: topic.message
            };
        }

        // Otherwise use predefined config
        if (topic.type && topic.type !== LeadTopicType.CUSTOM && topic.type in leadTopicConfig) {
            return leadTopicConfig[topic.type as LeadTopicType];
        }

        // Fallback to empty strings
        return {
            title: "",
            message: ""
        };
    }, [topic]);

    return (
        <div className={css({p: 3, w: "100%", md: {maxW: "556px"}})}>
            <CloseIconButton top={2} right={2} className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

            <TopicForm
                {...props}
                customHeader={
                    <Text variant="headline_4" as="p" mb={3} className={css({textAlign: "left", pr: 4, md: {textAlign: "center"}})}>
                        {title}
                    </Text>
                }
                defaultMessage={message}
            />
        </div>
    );
};

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
